// extracted by mini-css-extract-plugin
export var cardWrapper = "_40-0";